<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import PlannerViewport from '@/views/3d-planner/PlannerViewport.vue';
    import PlannerOverlay from '@/views/3d-planner/PlannerOverlay.vue';
    import { usePlannerStore } from '@/views/3d-planner/store/plannerStore';
    import { usePlannerSceneViewModel } from '@/views/3d-planner/store/plannerSceneViewModel';
    import { watchImmediate } from '@vueuse/core';
    import { useVersion } from '@/stores/version';
    import { onMounted, onUnmounted } from 'vue';
    import { useHipSpineLoadingViewModel } from '@/views/3d-planner/hipSpine/useHipSpineLoadingViewModel';

    const route = useRoute();
    const plannerStore = usePlannerStore();
    const plannerScene = usePlannerSceneViewModel();
    const hipSpineLoading = useHipSpineLoadingViewModel();
    const versionStore = useVersion();
    await versionStore.load();

    watchImmediate(
        () => route.params.id,
        () => {
            // Rebuild the scene graph for the new case before the domain load — fresh nodes, so the
            // scene mounts onto a clean graph (the previous case's nodes can't be safely reused).
            plannerScene.resetScene();
            plannerStore.loadCase(Number(route.params.id));
        },
    );

    // Load the hip-spine study for the active case (the VM applies the org-feature gate).
    watchImmediate(
        () => [route.params.id, hipSpineLoading.hipSpineStudyId],
        () => hipSpineLoading.loadStudy(Number(route.params.id)),
    );

    // Save-sync follows study completion.
    watchImmediate(
        () => hipSpineLoading.isStudyCompleted,
        (completed) => hipSpineLoading.setSyncEnabled(completed),
    );

    onMounted(() => plannerStore.run());
    onUnmounted(() => {
        plannerStore.stop();
        hipSpineLoading.setSyncEnabled(false);
    });
</script>

<template>
    <planner-overlay>
        <planner-viewport />
    </planner-overlay>
</template>
